module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_5_1-22b1a92a417dd10f4e40ae33480bfd39.png";